exports = module.exports = require("../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".systemTitle[data-v-74a1309b] {\n  font-size: 16px;\n  font-weight: 800;\n  margin-bottom: 10px;\n}\nspan[data-v-74a1309b] {\n  margin: 0 20px;\n}", ""]);

// exports
